module.exports = __webpack_public_path__ + "static/media/eye.0f691b7d.svg";